export class Base64 {
  /* encoding utf-8 ⇢ base64 */
  static encodeUnicode(string: string) {
    string = encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(parseInt(p1, 16));
    });
    return btoa(string);
  }

  /* decoding base64 ⇢ utf-8 */
  static decodeUnicode(string: string) {
    string = atob(string);
    return decodeURIComponent(
      Array.prototype.map
        .call(string, (c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }

  static encodeFile(file: File): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve((reader.result as string).split(',')[1]);
      reader.onerror = () => reject(new Error('Error reading file!'));
    });
  }
}
